type WebViewNetworkDefaults = { networkMode?: 'always' };

/**
 * Default overrides that apply ONLY inside the mobile app's WebView; empty objects everywhere
 * else so desktop/browser behavior is untouched.
 *
 * - networkMode 'always' (queries AND mutations): navigator.onLine can report false in Android
 *   WebView, which would leave requests paused forever (no error, no result) instead of running
 *   and failing visibly. Mutations default to 'online' separately, so they need it too.
 *
 * There is deliberately NO retry cap here: boot-critical queries (the brands query behind
 * AuthLayout/ProtectedRoute) rely on the base policy's 3 retries to ride out a cold-start blip,
 * and the 408/425/429 backoff recovery needs its attempts. Queries that want fewer retries set
 * their own `retry`.
 */
export const buildWebViewQueryDefaults = (
  isWebView: boolean,
): { queries: WebViewNetworkDefaults; mutations: WebViewNetworkDefaults } => {
  if (!isWebView) return { queries: {}, mutations: {} };
  return {
    queries: { networkMode: 'always' },
    mutations: { networkMode: 'always' },
  };
};
